import { Injector } from "@angular/core";
import { WorkplaceActionHandlerBase } from "../../../../../../components/common/grid-base/actions/workplace-action-handler-base";
import { WorkplaceBase } from "../../../../../../components/common/workplace-base/workplace-base";

/**
 * Forwards a button click event
 */
export class ButtonEventForwarderWorkplaceActionHandler extends WorkplaceActionHandlerBase {
  /**
   * Constructor
   * @param injector Ihe Angular injector
   * @param workspace The workspace in which the action should be performed
   * @param topic Topic (subscribeEvent topic)
   * @param broadcastTopic Broadcast Topic (broadcastEvent topic)
   */
  constructor(injector: Injector, workplace: WorkplaceBase, topic: string, private broadcastTopic: string) {
    super(injector, workplace, topic);
  }

  /**
  * Handles an event
  * @param _payload The (untyped) payload. Can also be a callback function
  */
  public handle(_payload: any): void {
    this.eventBus.broadcastEvent(this.broadcastTopic, this.workplace);
  }
}
